export enum EAgentPaymentQueryKey {
  PAYMENT_INITIATE_DEPOSIT_FIAT = 'payment-initiate-deposit-fiat',
  PAYMENT_VERIFY_DEPOSIT_FIAT = 'payment-verify-deposit-fiat',
  CALCULATE_DEPOSIT_COST = 'calculate-deposit-cost',
  CALCULATE_WITHDRAWAL_COST = 'calculate-withdrawal-cost',
  GET_FIAT_TRANSACTION_HISTORY = 'get-fiat-transaction-history',
  INITIATE_WITHDRAW_FIAT = 'initiate-withdraw-fiat',
}
